// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";

function RegionFlag(props) {
  var sizeStr = String(props.size);
  return JsxRuntime.jsx("img", {
              className: props.className,
              alt: props.alt,
              height: sizeStr,
              src: props.src,
              width: sizeStr
            });
}

var make = RegionFlag;

export {
  make ,
}
/* react/jsx-runtime Not a pure module */
